module.exports = __webpack_public_path__ + "static/media/resume.bbed13ee.jpg";